import { ReactElement } from 'react';

import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { PatientMedicine, PatientMedicineQuery } from '@dreryk/egabinet-prescription-frontend-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { historicalVisitTranslationKeys } from '../../../../translations';

const t = historicalVisitTranslationKeys.copyPrescription;

type MedicineReplacementFormLoaderChildrenRenderProps = {
   readonly withdrawnMedicine: MedicineSimple;
};

type MedicineReplacementFormLoaderProps = {
   readonly medicineId: number;
   readonly patientId: Patient['id'];
   readonly children: (renderProps: MedicineReplacementFormLoaderChildrenRenderProps) => ReactElement;
};

export const MedicineReplacementFormLoader = (props: MedicineReplacementFormLoaderProps): ReactElement => {
   const { data, loading, error } = useCqrsSearch<PatientMedicine>(() => {
      const query = new PatientMedicineQuery();
      query.patientId = props.patientId;
      query.medicineId = Slot.of(props.medicineId);
      return query;
   });

   if (loading) {
      return <LoaderSpinner />;
   }

   if (error || !data?.length) {
      return (
         <Message
            testId={'medicineLoadError'}
            label={t.replacementError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({ withdrawnMedicine: data[0].medicine });
};
